import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Document from '../../document';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import { PERMISSIONS, IC_DOCUMENTS } from '../../document/types';
import { DocumentInfo } from '../../../utilities/documentTypes';
import { getDocuments } from '../../../reducers/documents';
import IcContinueRequestDocs from '../workerDocumentsICContinue';
import { beginsWith } from '../../../utilities/string';
import { isW2 } from '../../../utilities/jobStatus';

class DocumentsTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        const {
            getDocuments,
            job: { contractor_id },
            contractorId
        } = this.props;

        getDocuments({ type: 'contractor', id: contractor_id || contractorId });
    }

    getDocType(docInfo) {
        return (docInfo.typePrefix || '') + docInfo.docType;
    }

    getDocInfosWithPrefix(prefix) {
        let result = [];
        for (const key of Object.keys(DocumentInfo.types)) {
            const docInfo = DocumentInfo.types[key];
            if (docInfo.typePrefix && beginsWith(docInfo.typePrefix, prefix)) {
                result.push(docInfo);
            }
        }
        return result;
    }

    getExcludeDocInfos(roleType) {
        const { ADMIN_PAY_STUB, CONTRACTOR_USA_I9_SIGNED, CONTRACTOR_CLIENT_DOC, ADMIN_I9 } = DocumentInfo.types;

        switch (roleType) {
            case 'admin':
                return [ADMIN_PAY_STUB, CONTRACTOR_USA_I9_SIGNED, CONTRACTOR_CLIENT_DOC];

            case 'client':
            default:
                return [ADMIN_PAY_STUB, CONTRACTOR_USA_I9_SIGNED, ADMIN_I9, CONTRACTOR_CLIENT_DOC, ...this.getDocInfosWithPrefix('i9')];
        }
    }

    render() {
        const { job, documents, roleType } = this.props;
        const { contractor_id } = job;

        if (!documents) return null;
        const { CONTRACTOR_USA_I9_SIGNED, CONTRACTOR_CLIENT_DOC } = DocumentInfo.types;
        const excludeDocInfos = this.getExcludeDocInfos(roleType);
        const excludeDocs = excludeDocInfos.map(d => this.getDocType(d)).concat(Object.keys(IC_DOCUMENTS));

        return (
            <div className="worker-documents-tab">
                {roleType === 'admin' &&
                    (isW2(job) ? (
                        <div className="row group">
                            <div className="col-xs-12">
                                <div className="section-title">
                                    <FormattedMessage {...messages.docSignedI9} />
                                </div>
                                <Document
                                    {...CONTRACTOR_USA_I9_SIGNED}
                                    id={`signed-i9-upload-${contractor_id}`}
                                    ownerRole={{ type: 'contractor', id: contractor_id }}
                                    upload={roleType === 'admin' && { limit: 1, permissions: PERMISSIONS.DEFAULT }}
                                    providedDocuments={documents}
                                    view={{ showHeader: false }}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="row group">
                            <div className="col-xs-12">
                                <div className="section-title">
                                    <FormattedMessage {...messages.icDocs} />
                                </div>
                                <IcContinueRequestDocs role={{ type: 'contractor', id: contractor_id }} />
                            </div>
                        </div>
                    ))}

                {['admin', 'client'].includes(roleType) && (
                    <div className="row group">
                        <div className="col-xs-12">
                            <div className="section-title">
                                <FormattedMessage {...messages.clientSpecificDocs} />
                            </div>
                            <Document
                                {...CONTRACTOR_CLIENT_DOC}
                                id={`clientdoc-${contractor_id}`}
                                ownerRole={{ type: 'contractor', id: contractor_id }}
                                upload={['admin', 'client'].includes(roleType) && { limit: 5, permissions: PERMISSIONS.DEFAULT }}
                                providedDocuments={documents}
                                view={{ showHeader: false }}
                            />
                        </div>
                    </div>
                )}

                <div className="row">
                    <div className="col-xs-12">
                        <div className="section-title">
                            <FormattedMessage {...messages.otherDocuments} />
                        </div>
                        <Document
                            excludeDocTypes={excludeDocs}
                            ownerRole={{ type: 'contractor', id: contractor_id }}
                            id={`${contractor_id}-all`}
                            providedDocuments={documents}
                            view={{ showHeader: false }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

DocumentsTab.defaultProps = {
    job: {}
};

const mapStateToProps = (state, props) => {
    const role = state.identity.role;
    const contractorId = props.job ? props.job.contractor_id : undefined;
    const prop = contractorId ? `${contractorId}-all` : undefined;
    const docs = prop ? state.documents[prop] : undefined;

    return {
        role,
        documents: docs ? docs.list : undefined
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getDocuments
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsTab);



// WEBPACK FOOTER //
// ./src/components/lists/workerDocuments/index.jsx